/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(
        /* webpackChunkName: "orders" */ '@/modules/products/scenes/products-list/products-list.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.PRODUCTS.PRODUCTS,
    path: 'products/list'
  }
] as RouteConfig[];
